import { useQuery } from '@tanstack/react-query';
import { hrmsApi } from '@/api/hrms';
import { queryKeys } from '@/query/queryKeys';

const useHrmsHolidaysQuery = (enabled: boolean) =>
  useQuery({
    queryKey: queryKeys.hrmsHolidays(),
    queryFn: () => hrmsApi.listHolidays(),
    enabled,
    retry: false,
  });

const useHrmsAttendanceCurrentStatusQuery = (enabled: boolean) =>
  useQuery({
    queryKey: queryKeys.hrmsAttendanceCurrentStatus(),
    queryFn: () => hrmsApi.getCurrentAttendanceStatus(),
    enabled,
    retry: false,
  });

const useHrmsDailyAttendanceReportQuery = (enabled: boolean, date?: string) =>
  useQuery({
    queryKey: queryKeys.hrmsAttendanceDailyReport(date ?? ''),
    queryFn: () => (date ? hrmsApi.getDailyAttendanceReport(date) : Promise.resolve({ date: '', rows: [] })),
    enabled: enabled && Boolean(date),
    retry: false,
  });

const useHrmsMonthlyAttendanceReportQuery = (enabled: boolean, month?: number, year?: number) =>
  useQuery({
    queryKey: queryKeys.hrmsAttendanceMonthlyReport(String(year ?? ''), String(month ?? '')),
    queryFn: () =>
      typeof month === 'number' && typeof year === 'number'
        ? hrmsApi.getMonthlyAttendanceReport(month, year)
        : Promise.resolve([]),
    enabled: enabled && typeof month === 'number' && typeof year === 'number',
    retry: false,
  });

export {
  useHrmsHolidaysQuery,
  useHrmsAttendanceCurrentStatusQuery,
  useHrmsDailyAttendanceReportQuery,
  useHrmsMonthlyAttendanceReportQuery,
};

